// extracted by mini-css-extract-plugin
export default {"wrapper":"c6af37dd9c7a"};